(function () {
  var serviceId = "applicationSettingsService";
  angular
    .module("app")
    .service(serviceId, applicationSettingsService);
  applicationSettingsService.$inject = [
    "$window",
    "defaultDimensions",
    "UserProvider",
    "conversionService",
    "_"
  ];

  function applicationSettingsService($window, defaultDimensions, UserProvider,conversionService, _) {
    var isPremium = UserProvider.getUser().isPremium();
    var storageKey = "userCfg" + hashCode(UserProvider.getUser().userId, UserProvider.getUser().accountId);
    var service = {
      getUserCfg: getUserCfg,
      setUserCfg: setUserCfg,
      updateUserCfg: updateUserCfg,
      getDefaultUserCfg: getDefaultUserCfg,
      resetUserCfg: resetUserCfg,
      changeUnits: changeUnits,

    };

    return service;

    //////////////////////////////////////////////////////////

    function getUserCfg(key) {
      var userCfg = $window.localStorage.getItem(storageKey);
      if (userCfg != null && userCfg != "undefined") {
        var obj = JSON.parse(userCfg);
        return key ? obj[key] : obj;
      }
      var cfg = getDefaultUserCfg();
      setUserCfg(cfg);
      return key ? cfg[key] : cfg;
    }

    function getDefaultUserCfg(key) {
      var userCfg = {};
      userCfg.afSetIDs = "";
      var currentUserConfig = $window.localStorage.getItem(storageKey);
      if (currentUserConfig != null && currentUserConfig != "undefined") {
        var obj = JSON.parse(currentUserConfig);
        if(obj && obj.Minimum_Data_Version_Used) {
          userCfg.Minimum_Data_Version_Used = obj.Minimum_Data_Version_Used;
        }
      }
      if (isPremium) {
        userCfg.classicSearchView = false;
        userCfg.includePOI = false;
        userCfg.mapLayers = {
          traffic: false,
          weatherRadar: false,
          weatherCloud: false,
          roadSurface: false,
          weatherAlerts: false,
          alkPlaces: false,
          customPlaces: false
        };
      } else {
        userCfg.classicSearchView = true;
      }
      return key ? userCfg[key] : userCfg;
    }

    function setUserCfg(config) {
      $window.localStorage.setItem(storageKey, JSON.stringify(config));
    }

    function updateUserCfg(config) {
      var val = JSON.stringify(_.defaults(config, getUserCfg()));
      $window.localStorage.setItem(storageKey, val);
    }

    function resetUserCfg() {
      $window.localStorage.setItem(storageKey, JSON.stringify(getDefaultUserCfg()));
      return getUserCfg();
    }

    function hashCode(a,b) {
      var num = 3 * a + 7 * b;
      var str = num.toString();
      var hash = 5381;
      for (var i = 0; i < str.length; i++) {
        var char = str.charCodeAt(i);
        hash = ((hash << 5) + hash) + char; /* hash * 33 + c */
      }
      return hash;
    }

    function changeUnits(routeOptions) {
      var max = defaultDimensions.max;
      var min = defaultDimensions.min;
      var NUM_INCHES_IN_FOOT = 12;
      var region = UserProvider.getUser().region;
      // english unit, check bounds for each value
      if (routeOptions.trkUnits === 0) {
        routeOptions.trkWeight = conversionService.bounds(min.weightEnglish,max.weightEnglish,
          conversionService.kilogramsToPounds(routeOptions.trkWeight));

        var lengthInInches = conversionService.bounds(min.lengthEnglish * NUM_INCHES_IN_FOOT, max.lengthEnglish * NUM_INCHES_IN_FOOT,
          conversionService.metersToInches(routeOptions.trkLength));
        routeOptions.trkLength = conversionService.totalInchesToString(lengthInInches);

        var heightInInches = conversionService.bounds(min.heightEnglish * NUM_INCHES_IN_FOOT, max.heightEnglish * NUM_INCHES_IN_FOOT,
          conversionService.metersToInches(routeOptions.trkHeight));
        routeOptions.trkHeight = conversionService.totalInchesToString(heightInInches);
        // 2.43 => "96\""
        routeOptions.trkWidth = conversionService.bounds(min.widthEnglish, max.widthEnglish,
          conversionService.metersToInches(routeOptions.trkWidth));
        routeOptions.trkWidth = conversionService.totalInchesToString(routeOptions.trkWidth, true);

        routeOptions.governorSpeedLimit = (routeOptions.governorSpeedLimit != null) ? Math.floor(routeOptions.governorSpeedLimit / 1.60) : routeOptions.governorSpeedLimit; // km to miles
        routeOptions.elevLimit = (routeOptions.elevLimit != null) ? Math.floor(routeOptions.elevLimit * 3.28) : routeOptions.elevLimit; // meters to feet
        // we will use same unit for distance and truck.
        routeOptions.distanceUnits = 0;

        if (region === "EU") {
          routeOptions.EUOptions.trlMaxWt = Math.floor(conversionService.bounds(min.trlWeightEnglish, max.trlWeightEnglish,
            conversionService.kilogramsToPounds(routeOptions.EUOptions.trlMaxWt)));

          var trlHeightInInches = conversionService.bounds(min.trlHeightEnglish * NUM_INCHES_IN_FOOT, max.trlHeightEnglish * NUM_INCHES_IN_FOOT,
            conversionService.metersToInches(routeOptions.EUOptions.trlMaxHt));
          routeOptions.EUOptions.trlMaxHt = conversionService.totalInchesToString(trlHeightInInches);
        }

      } else { // metric unit, check bounds for each value
        routeOptions.trkWeight = conversionService.bounds(min.weightMetric, max.weightMetric,
          conversionService.poundsToKilograms(routeOptions.trkWeight, 2));

        if (!Array.isArray(routeOptions.trkLength)) {
          routeOptions.trkLength = conversionService.stringToFeetInches(routeOptions.trkLength);
          routeOptions.trkHeight = conversionService.stringToFeetInches(routeOptions.trkHeight);
        }
        routeOptions.trkLength = conversionService.bounds(min.lengthMetric, max.lengthMetric,
          conversionService.feetInchesToMeters(routeOptions.trkLength[0], routeOptions.trkLength[1], 4));
        routeOptions.trkHeight = conversionService.bounds(min.heightMetric, max.heightMetric,
          conversionService.feetInchesToMeters(routeOptions.trkHeight[0], routeOptions.trkHeight[1], 4));
        // "96\"" => 2.43
        routeOptions.trkWidth = conversionService.bounds(min.widthMetric, max.widthMetric,
          conversionService.inchesToMeters(conversionService.stringToTotalInches(routeOptions.trkWidth), 2));

        routeOptions.governorSpeedLimit = (routeOptions.governorSpeedLimit != null) ? Math.floor(routeOptions.governorSpeedLimit * 1.60) : routeOptions.governorSpeedLimit; // miles to km
        routeOptions.elevLimit = (routeOptions.elevLimit != null) ? Math.floor(routeOptions.elevLimit / 3.28) : routeOptions.elevLimit; // feet to meters
        // we will use same unit for distance and truck.
        routeOptions.distanceUnits = 1;

        if (region === "EU") {
          routeOptions.EUOptions.trlMaxWt = Math.floor(conversionService.bounds(min.trlWeightMetric, max.trlWeightMetric,
            conversionService.poundsToKilograms(routeOptions.EUOptions.trlMaxWt)));

          if (!Array.isArray(routeOptions.EUOptions.trlMaxHt)) {
            routeOptions.EUOptions.trlMaxHt = conversionService.stringToFeetInches(routeOptions.EUOptions.trlMaxHt);
          }
          routeOptions.EUOptions.trlMaxHt = conversionService.bounds(min.heightMetric, max.heightMetric,
            conversionService.feetInchesToMeters(routeOptions.EUOptions.trlMaxHt[0], routeOptions.EUOptions.trlMaxHt[1], 4));
        }
      }
      return routeOptions;
    }
  };
})();




// WEBPACK FOOTER //
// ./app/applicationSettings/applicationSettings.service.js